// import { instance, instanceEndUser } from "./service/instance";
import { apiSlice } from "../api/apiSlice";

export const companyApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCompListUid: builder.query<any, any>({
      query: (params) => {
        return {
          url: `/company/list-uid-names`,
          params: params,
        };
      },
      providesTags: ["GetCompListUid"],
    }),
    getCompListDetail: builder.mutation<any, any>({
      query: (uid) => {
        return {
          url: `/company/get-company-detail/${uid}`,
          methods: "GET",
        };
      },
    }),
    createCmpny: builder.mutation<any, any>({
      query: (params) => {
        return {
          url: `/company/create-company`,
          method: "POST",
          body: params,
        };
      },
      invalidatesTags: ["CompanyList"],
    }),
    updateCmpny: builder.mutation<any, any>({
      query: ({ params, uid }) => {
        return {
          url: `/company/update-company/${uid}`,
          method: "PUT",
          body: params,
        };
      },
      invalidatesTags: ["CompanyList"],
    }),
    deleteCmpny: builder.mutation<any, any>({
      query: (uid) => {
        return {
          url: `/company/delete-company/${uid}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["CompanyList"],
    }),
  }),
});

export const {
  useGetCompListUidQuery,
  useGetCompListDetailMutation,
  useCreateCmpnyMutation,
  useUpdateCmpnyMutation,
  useDeleteCmpnyMutation,
} = companyApiSlice;
